import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { registrationPage2Request, registrationPage2Success, registrationPage2Failure } from '../reducers/login';
import { xapiRequest } from '../reducers/xapi';
import { API_LINK } from '../../constants';
import * as moment from 'moment';
const API = `${API_LINK}api/registerPage3`;

function* registrationPage2FunctionAxios() {
 
  const state = yield select(fullState => fullState);
  
  const {
    
    race,
    language,
    disability,
    conSocioEconomicStatus,
    highestQualification,
    highestSchoolLevel,
    nationality,
    residenceStatus,
    lastSchoolEmis,
    lastSchoolYear,
    socc,
    rating
  } = state.form.registration.values;
 
  const amLeader =  0;
  const dob = moment(state.form.registration.values.birthdate).format('YYYY-MM-DD')
  const { userId } = state.loginReducer.user;
  const { lastSchool, sightRating,hearRating, walkRating, commRating, selfcareRating, memoryRating } = state.viewReducer;

  var hsId = highestSchoolLevel;
  if( Array.isArray(hsId)){
    hsId= highestSchoolLevel[0];
  }
  var hqId = highestQualification;
  if( Array.isArray(hqId)){
    hqId= highestQualification[0];
  }
  var cses = conSocioEconomicStatus;
  if( Array.isArray(cses)){
    cses= conSocioEconomicStatus[0];
  }
  var r = race;
  if( Array.isArray(r)){
    r= race[0];
  }
  var d = disability;
  if( Array.isArray(d)){
    d= disability[0];
  }
  var s = socc;
  if( Array.isArray(s)){
    s= socc[0];
  }
  var l = language;
  if( Array.isArray(l)){
    l= language[0];
  }
 
  var n = nationality;
  if( Array.isArray(n)){
    n= nationality[0];
  }
  console.log('rating now', rating)
  const response = yield call(() => {
    return axios({
      method: 'post',
      url: API+'/'+userId,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        highestSchoolLevel: hsId,
        highestQualification: hqId,
        conSocioEconomicStatusID:  cses,
        race: r,
        conDisabilityStatusID: d,
        conDisabilityRatingID: rating ?rating[0] : 0,
        conLanguageID: l,
        socc: s,
        nationality: n,
        residenceStatus: residenceStatus[0],
        platform: 'web',
        lastSchool: lastSchool,
        lastSchoolYear: lastSchoolYear,
        sightRating: sightRating[0],
        hearRating: hearRating[0],
        walkRating: walkRating[0],
        commRating: commRating[0],
        memoryRating:memoryRating[0],
        selfcareRating: selfcareRating[0]
      },
    });
  });
  
  return response;
}

function* workerRegistrationPage2Saga() {
  try {
    const response = yield call(registrationPage2FunctionAxios);
    const responseFromLogin = response.data;

    if (response.status === 200) {
      yield put(registrationPage2Success(responseFromLogin));
      yield put(xapiRequest({ xapiType: 'Registration 2' }));
    }

    if (response.status === 205) {
      yield put(registrationPage2Failure('Email does not exist'));
    }
    if (response.status === 206) {
      yield put(registrationPage2Failure(response.data));
    }
    if (response.status === 208) {
      yield put(registrationPage2Failure(response.data));
    }
    if (response.status === 500) {
      yield put(registrationPage2Failure(response.statusText));
    }
  } catch (error) {
    
    yield put(registrationPage2Failure(error));
  }
}

export function* watcherRegistrationPage2Saga() {
  yield takeLatest(registrationPage2Request().type, workerRegistrationPage2Saga);
}
